<template>
  <div class="row">
    <div class="col-12 mb-2">
      <b-card header="CIS Statement Export" header-tag="h4" class="bg-default-card">
        <div class="row">
          <div class="col-6 offset-96">

            <!-- Form with Validation -->
            <p>Add CIS to the queue. <br>Once CIS is processed it will be send to your (or worker) email.</p>
            <ValidationObserver v-slot="{ invalid, validate }">
              <form role="form" @submit.prevent="validateAndSubmit(validate)" class="row-form mb-3" autocomplete="off">

                <!-- Financial Year-->
                <div class="form-group col-6">
                  <label for="year">Select Year</label>
                  <select id="year" class="form-control" v-model="selectedYear" @change="getYearData()">
                    <option v-for="(desc, year) in financialYears" :value="year">{{ desc }}</option>
                  </select>
                </div>

<!--                &lt;!&ndash; Radio Button Options &ndash;&gt;-->
<!--                <div class="form-group col-8">-->
<!--                  <b-form-group label="Select period type">-->
<!--                      <b-select v-model="selectedType" name="radio-options">-->
<!--                          <b-select-option value="REPORT_TYPE_YEARLY">Annually</b-select-option>-->
<!--                      </b-select>-->
<!--                  </b-form-group>-->
<!--                </div>-->

<!--                <div v-if="selectedType === 'W'" class="form-group col-6">-->
<!--                  <label for="period">Select Week</label>-->
<!--                  <select id="period" class="form-control" v-model="selectedWeek">-->
<!--                    <option v-for="(desc, week) in financialYearData.weeks" :value="week">{{ desc }}</option>-->
<!--                  </select>-->
<!--                </div>-->

                <div v-if="selectedType === 'REPORT_TYPE_MONTHLY'" class="form-group col-6">
                  <label for="period">Select Month</label>
                  <select id="period" class="form-control"  v-model="selectedMonth">
                    <option v-for="(desc, month) in financialYearData.months" :value="month">{{ desc }}</option>
                  </select>
                </div>

                <!-- Checkbox for sending to email -->
                <div class="form-group col-6">
                  <ValidationProvider name="sendEmail" v-slot="{ errors }">
                    <label class="checkbox-inline">
                      <input type="checkbox" v-model="sendToEmail" />
                      Send Email To Worker
                    </label>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Submit Button -->
                <div>
                  <button :disabled="loadingButton" type="submit" class="btn orcaBtn w-100">
                    Generate Statement
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>

    <div class="col-12 mb-2">
      <b-card header="CIS Statement Export History" header-tag="h4" class="bg-default-card">
        <div class="row">
          <div class="col-12 mt-4">
            <datatable :type="''"
                       :recordType="''"
                       :rowData="rows"
                       :loadingMessage="loadingMessage"
                       :noRowsMessage="noRowsMessage"
                       :columns="columns"

            >
            </datatable>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import datatable from "datatables/export_datatable";
import _ from 'underscore-contrib';
import lodash from 'lodash';
import password_toggle from './components/password_toggle.vue';

Vue.use(_);
Vue.use(lodash);

export default {
  name: "cis_statements",
  components: {
    Multiselect,
      password_toggle,
    datatable,
      'button_commands': {
          name: 'button_commands',
          template: '<button type="button" class="btn btn-success" @click="this.onClick" :data-id="`${params.data.id}`" :data-worker-id="`${params.data.worker_id}`">Delete</button>',
          methods:{
            onClick: async function(e){
                try{
                    let r = await axios.delete(`${this.crmApiPath}worker/cis/messages/${this.params.data.worker_id}/delete_cis/${this.params.data.id}`);

                    if(r.status === 200){
                        this.$parent.$parent.$parent._self.refreshSTtable = 1;
                    }
                }
                catch (e){
                    console.error(e);
                }
            }
          }
      },
      'status': {
          name: 'status',
          components: {
              password_toggle
          },
          template: `
            <div>
                <div v-if="params.data.status !== 'COMPLETED'">
                    <div v-if="params.data.last_error && params.data.status === 'ERROR'">
                        Failed: {{params.data.last_error}}
                    </div>
                    <div v-else>
                        {{params.data.status}}
                    </div>
                </div>
                <div v-else-if="params.data.report_rel_file_path">
                    <password_toggle :password="params.data.report_pwd" :download-url="'/storage/' + params.data.report_rel_file_path"/>
                </div>
            </div>
          `
      }
  },
  props: {
    worker: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      refreshInterval: null,
      heightStyle: 'height: 400px !important',
      loadingMessage: 'Loading CIS statements...',
      loadingButton: false,
      noRowsMessage: 'No CIS statements found',
      rows: null,
      refreshSTtable: 0,
      financialYears: {},
      financialYearData: {},
      selectedType: 'REPORT_TYPE_YEARLY',
      selectedYear: null,
      selectedMonth: null,
      selectedWeek: null,
      employment_type: null,
      sendToEmail: false,
      columns: [
          { headerName: 'Report Type', field: 'report_type', valueGetter: this.reportTypeGetter, minWidth: 105, suppressSizeToFit: true },
          { headerName: 'Employment type', valueGetter: this.employmentTypeGetter, field: 'employment_type', suppressSizeToFit: true },
          { headerName: 'Ref', field: 'ref', suppressSizeToFit: true },
          { headerName: 'Ref type', field: 'ref_type', valueGetter: this.refTypeGetter, suppressSizeToFit: true },
          { headerName: 'Start', field: 'start_date', suppressSizeToFit: true },
          { headerName: 'End', field: 'end_date', suppressSizeToFit: true },
          { headerName: 'Send Email', valueGetter: this.emailGetter, suppressSizeToFit: true },
          { headerName: 'Created At', valueGetter: this.created_at_getter, suppressSizeToFit: true },
          { headerName: 'Status', suppressSizeToFit: true,
              cellRendererFramework: 'status'
          },
          { headerName: 'Commands', suppressSizeToFit: true,
              cellRendererFramework: 'button_commands'
          }
      ],
      exporting: false
    };
  },
  beforeMount() {

    axios.get(this.crmApiPath + 'worker/cis/financial_years')
        .then((response) => {
            this.selectedYear = Object.keys(response.data.data).reverse()[0];
            this.financialYears = response.data.data;
            this.getYearData();
        })
  },
  mounted() {
    this.get_data();
    let self = this;
      this.refreshInterval = window.setInterval(() => {
          self.refreshSTtable = 1;
      }, 25000);
  },
beforeDestroy () {
    if (this.refreshInterval) {
        window.clearInterval(this.refreshInterval);
        this.refreshInterval = null;
    }
},
  methods: {
    validateAndSubmit(validate) {
      // Trigger validation
      validate().then(success => {
        if (success) {
          this.submitData();
        }
      });
    },
    getYearData() {
      axios.get(this.crmApiPath + 'worker/cis/financial_year/' + this.selectedYear)
        .then((response) => {
          this.financialYearData = response.data.data;
          this.selectedMonth = this.financialYearData.currentMonth;
          this.selectedWeek = this.financialYearData.currentWeek;
        })
    },
    getMonth() {
      if(this.selectedType === 'Y') {
        return this.selectedYear;
      }

      if(this.selectedType === 'M') {
        return this.selectedMonth;
      }

      if(this.selectedType === 'W') {
        return this.selectedWeek;
      }
    },
    submitData() {
      this.loadingButton = true;
      axios.post(this.crmApiPath + 'worker/cis/generate', {
        year: this.selectedYear,
        report_type: this.selectedType,
        month: this.getMonth(),
        send_email: this.sendToEmail ? 1 : 0,
        worker_id: this.worker.id,
      })
        .then((response) => {
            if(response.status === 207){
                alert('Could not generate some reports...')
            }

          this.refreshSTtable = 1;
          this.$snotify.success('CIS added to the queue');
        })
        .catch(error => {
          if (error.response) {
              let validationErrors;
              let errorMessages;
              switch(error.response.status){
                  case 400:
                  case 409:
                      validationErrors = error.response.data.validation_errors;
                      errorMessages = [];

                      if (validationErrors) {
                          for (const [field, messages] of Object.entries(validationErrors)) {
                              if (Array.isArray(messages)) {
                                  errorMessages.push(`${messages.join(', ')}`);
                              } else {
                                  errorMessages.push(`${messages}`);
                              }
                          }
                      }
                      if (errorMessages.length > 0) {
                          alert(errorMessages.join('\n'));
                      } else {
                          alert('An unknown processing error occurred.');
                      }
                      break;
                  case 403:
                      validationErrors = error.response.data.validation_errors;
                      errorMessages = ['Access denied: You do not have permission to perform this action.'];

                      if (validationErrors) {
                          for (const [field, messages] of Object.entries(validationErrors)) {
                              if (Array.isArray(messages)) {
                                  errorMessages.push(`${field}: ${messages.join(', ')}`);
                              } else {
                                  errorMessages.push(`${field}: ${messages}`);
                              }
                          }
                      }
                      alert(errorMessages.join('\n'));
                      break;
              }
            } else {
              alert('An error occurred. Please try again later.');
            }
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    get_data() {
      axios.get(`${this.crmApiPath}worker/cis/status/${this.worker.id}`)
        .then(res => {
          this.rows = res.data.data;
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
    },
    created_at_getter(params) {
      return this.$options.filters.formatDateTimeYMD(params.data.created_at);
    },
    emailGetter(params) {
      return lodash.upperFirst(lodash.lowerCase(params.data.send_email === 1 ? "YES" : "NO"));
    },
    reportTypeGetter(params) {
      switch (params.data.report_type) {
          case 'REPORT_TYPE_YEARLY':
              return 'Year';
          case 'REPORT_TYPE_MONTHLY':
              return 'Month';
          case 'REPORT_TYPE_WEEKLY':
              return 'Week';
          default:
              return '?'
      }
    },
    refTypeGetter(params) {
      switch (params.data.ref_type) {
          case 'REF_TYPE_WORKER':
              return 'Worker';
          case 'REF_TYPE_WORKER_COMPANY':
              return 'Company';
          default:
              return '?'
      }
    },

    employmentTypeGetter(params) {
      switch (params.data.employment_type) {
        case 'TYPE_CONTRACT':
          return 'Contract';
        case 'TYPE_PAYROLL':
          return 'Payroll';
        default:
          return '?'
      }
    }
  },
  watch: {
    refreshSTtable(val) {
      if (val === 1) {
        this.rows = [];
        this.get_data();
        this.refreshSTtable = 0;
      }
    }
  }
};
</script>
